export const baseApiUrl = process.env.VUE_APP_BASE_API_URL;
export const baseAuthApiUrl = process.env.VUE_APP_BASE_AUTH_API_URL;
export const baseFrontendUrl = process.env.VUE_APP_BASE_FRONTEND_URL;
export const baseFrotendAuth = process.env.VUE_APP_BASE_FRONTEND_AUTH_URL;

export default { baseApiUrl, baseFrotendAuth, baseFrontendUrl, baseAuthApiUrl };